{
  "Accessibility Menu": "Přístupnostní menu",
  "Reset settings": "Obnovit nastavení",
  "Close": "Zavřít",
  "Content Adjustments": "Úpravy obsahu",
  "Adjust Font Size": "Nastavit velikost písma",
  "Highlight Title": "Zvýraznit nadpis",
  "Highlight Links": "Zvýraznit odkazy",
  "Readable Font": "Čitelný font",
  "Color Adjustments": "Nastavení barev",
  "Dark Contrast": "Tmavý kontrast",
  "Light Contrast": "Světlý kontrast",
  "High Contrast": "Vysoký kontrast",
  "High Saturation": "Vysoká saturace",
  "Low Saturation": "Nízká saturace",
  "Monochrome": "Monochromatický",
  "Contrast": "Kontrast",
  "Invert Colors": "Invertovat barvy",
  "Tools": "Nástroje",
  "Reading Guide": "Průvodce čtením",
  "Stop Animations": "Zastavit animace",
  "Big Cursor": "Velký kurzor",
  "Increase Font Size": "Zvětšit velikost písma",
  "Decrease Font Size": "Zmenšit velikost písma",
  "Letter Spacing": "Mezery mezi písmeny",
  "Line Height": "Výška řádku",
  "Font Weight": "Tloušťka písma",
  "Dyslexia Font": "Dyslexický font",
  "Language": "Jazyk",
  "Open Accessibility Menu": "Otevřít přístupnostní menu",
  "Widget Settings": "Nastavení widgetu",
  "Widget Position": "Pozice widgetu",
  "Top Left": "Nahoře vlevo",
  "Top Center": "Nahoře uprostřed",
  "Top Right": "Nahoře vpravo",
  "Center Left": "Uprostřed vlevo",
  "Center Right": "Uprostřed vpravo",
  "Bottom Left": "Dole vlevo",
  "Bottom Center": "Dole uprostřed",
  "Bottom Right": "Dole vpravo",
  "Screen Reader": "Čtečka obrazovky",
  "Voice Navigation": "Hlasová navigace",
  "Custom Color": "Vlastní barva",
  "Change the site's colors": "Změňte barvy webu",
  "Backgrounds": "Pozadí",
  "Headings": "Nadpisy",
  "Contents": "Obsah",
  "Reset colors": "Obnovit barvy",
  "Image Desaturation": "Desaturace obrázku",
  "Search languages": "Hledat jazyky",
  "No languages found": "Nebyly nalezeny žádné jazyky",
  "Accessibility Profiles": "Profily přístupnosti",
  "Motor Impaired": "Motorické postižení",
  "Big cursor, voice navigation, and no animations.": "Velký kurzor, hlasová navigace a žádné animace.",
  "Blind": "Nevidomý",
  "Screen reader helpers with higher contrast.": "Pomůcky pro čtečky obrazovky s vyšším kontrastem.",
  "Color Blind": "Barvoslepost",
  "High contrast palette with desaturated media.": "Paleta s vysokým kontrastem a odbarvenými médii.",
  "Dyslexia": "Dyslexie",
  "Friendly font, extra spacing, stronger weight.": "Čitelný font, větší rozestupy a silnější písmo.",
  "Low vision": "Slabozrakost",
  "Dark contrast and 130% magnification.": "Tmavý kontrast a zvětšení o 130 %.",
  "Cognitive & Learning": "Kognitivní a učení",
  "Highlights key sections and enables voice help.": "Zvýrazní klíčové sekce a povolí hlasovou pomoc.",
  "Seizure & Epileptic": "Záchvaty a epilepsie",
  "Stops animations and desaturates imagery.": "Zastaví animace a odbarví obrázky.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Průvodce čtením, zvýrazněné odkazy a klidnější paleta.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
